import * as moment from 'moment'
import EDHttp from '../utils/EDHttp';
import Auth from './auth';
export default 
{
    requestMSDInformation:function(id) {
        return new Promise((resolve,reject)=>
        {
            EDHttp.post(`/user/request/msd/${id}`).then(result=>
                    {
                        if(result&&!result.data.error)
                            resolve(true);
                        else
                            reject('Error');
                    },error=>reject(error)).catch(error=>reject(error))
        })
    },
    forceConfirmInformation:function(id) {
        return new Promise((resolve,reject)=>
        {
            EDHttp.post(`/recertification/start/${id}`).then(result=>
                    {
                        if(result&&!result.data.error)
                            resolve(true);
                        else
                            reject('Error');
                    },error=>reject(error)).catch(error=>reject(error))
        })
    },
    sendRecertificationReminder:function(id) {
        return new Promise((resolve,reject)=>
        {
            EDHttp.put(`/recertification/reminder/${id}`).then(result=>
                    {
                        if(result&&!result.data.error)
                            resolve(result.data.data);
                        else
                            reject('Error');
                    },error=>reject(error)).catch(error=>reject(error))
        })
    },
    load:function(search="",status="")
    {
        return new Promise((resolve,reject)=>
        {
            if(!Auth.account.owner)
                reject('Unauthorized');
            else
            EDHttp.get(`/users${search?`/${search}`:''}?status=${status}`).then(result=>
                    {
                        if(result&&!result.data.error)
                            resolve(result.data.data);
                        else
                            reject('Error');
                    },error=>reject(error)).catch(error=>reject(error))
        })
    },
    call:function(id)
    {
        return new Promise((resolve,reject)=>
        {
            EDHttp.post(`/admin/call/${id}`,{}).then(result=>
                    {
                        if(result&&!result.data.error)
                            resolve(result.data.data);
                        else
                            reject('Error');
                    },error=>reject(error)).catch(error=>reject(error))
        })
    },
    reset: async function (id, password = "") {
        try {
            const result = await EDHttp.post(`/admin/reset/auth/${id}`,{password});
            return result.data.data;
        } catch (error) {
            throw error.response.data.message;
        }
    },
        discard: async function (id) {
            try {
                await EDHttp.post(`/admin/discard/${id}`)
            } catch (error) {
                throw new Error(error?.response?.data.message || "Error processing your request at this time")
            }
        },
        activate: async function (id, token = "") {

            try {
                const response = await EDHttp.post(`/admin/activate/${id}`, { token });
                return response.data.data
            } catch (error) {
                throw error.response.data.message
            }
        },

        delete: function (id) {
        return new Promise((resolve,reject)=>
        {
            if(!Auth.account.owner)
                reject('Unauthorized');
            else
                EDHttp.patch('/users',{id}).then(result=>
                    {
                        if(result&&!result.data.error)
                            resolve(result.data.data);
                        else
                            reject('Error');
                    },error=>reject(error)).catch(error=>reject(error))
        })
    },
    get:function(id)
    {
        return new Promise((resolve,reject)=>
        {
            if(!Auth.account.owner)
                reject('Unauthorized');
            else
                EDHttp.get(`/user/${id}`).then(result=>
                    {
                        if(result&&!result.data.error)
                            resolve(result.data.data);
                        else
                            reject('Error');
                    },error=>reject(error)).catch(error=>reject(error))
        })
    },
    update:function(id,account)
    {
        return new Promise((resolve,reject)=>
        {
            if(!Auth.account.owner)
                reject('Unauthorized');
            else
                EDHttp.put("/users",{id,...account}).then(result=>
                    {
                        if(result&&!result.data.error)
                            resolve(result.data.data);
                        else
                            reject('Error');
                    },error=>reject(error)).catch(error=>reject(error))
        })
    },
    async getUserMSDs(userId) {
        try {
            const { data: result } = await EDHttp.get(`/admin/user/${userId}/msd`);
            return result.data;
        } catch(error) {
            throw error.response.data.message
        }
    },
    async getMSDComparison(oldMSDId, newMSDId) {
        try {
            const { data: result } = await EDHttp.get(`/admin/msd/comparison?old=${oldMSDId}&new=${newMSDId}`);
            return result.data;
        } catch(error) {
            throw error.response.data.message
        }
        
    },
    async impersonate(userId) {
        try {
            const { data: result } = await EDHttp.get(`/auth/impersonate/${userId}`);
            return result.data;
        } catch(error) {
            throw error.response.data.message
        }
        
    }
}
